import { createTheme } from '@mui/material/styles';

const PRIMARY_COLOR = '#002244'; // Corresponds to rgb(0, 34, 68)
const SECONDARY_COLOR = '#CFA22E'; // Corresponds to rgb(207, 162, 46)
const INFO_COLOR = '#007bff'

export const theme = createTheme({
  palette: {
    primary: {
      main: PRIMARY_COLOR,
    },
    secondary: {
      main: SECONDARY_COLOR,
    },
    info:{
      main: INFO_COLOR,
    },
    background: {
      default: '#ffffff', // White background
    },
    text: {
      primary: PRIMARY_COLOR, // Main text color
    },
  },
  typography: {
    fontFamily: 'inherit', // Or your custom font
  },
});